import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ObjectHelperService {
    /**
     * Creates an object with a deep merge from the two passed parameters
     * When a value is duplicated, the second object one will have preference in the final object
     * @param obj1 First object to merge
     * @param obj2 Second object to merge
     */
    deepObjectMerge(obj1: any, obj2: any): any {
        if (!obj1 && !obj2) {
            return undefined;
        }

        const result = { ...obj1 };

        for (const key in obj2) {
            if (Object.prototype.hasOwnProperty.call(obj2, key)) {
                if (typeof obj2[key] === 'object' && obj2[key] !== null) {
                    result[key] = this.deepObjectMerge(result[key], obj2[key]);
                } else {
                    result[key] = obj2[key];
                }
            }
        }

        return result;
    }
}
